import axios from "axios";
import { NotImportService } from "./service";
import { keycloak } from "../../../../../lib/keycloak";
import { filtersDTO, NotImportDataDTO, NotImportResponseDTO } from "./dto";

export class NotImportImpl implements NotImportService {

    public GetAllImport(filters: filtersDTO): Promise<NotImportResponseDTO> {
        return axios.get("/api/notification-import", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                notificationId: filters.notificationId
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

}